import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { getCounterPartReminderListURL } from '../constants';
import { getTitle } from '../utils/utilFunctions';

import ReminderList from './ReminderList';
import { getCounterPartReminderList } from './api/counterPartReminderAPI';

const CompaniesRemindersPage = ({ handleSnackbarOpen, liftUpStateToApp, errorHandling }) => {
  const [reminders, setReminders] = useState([]);

  const loadReminders = useCallback(async () => {
    try {
      const data = await getCounterPartReminderList();
      setReminders(data);
    } catch (err) {
      errorHandling(err, getCounterPartReminderListURL);
    }
  }, [errorHandling]);

  useEffect(() => {
    document.title = `Wiedervorlagen Unternehmen - ${getTitle()}`;
    loadReminders();
  }, [loadReminders]);

  const sortedReminders = useMemo(() => [...reminders].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate)), [reminders]);

  return (
    <div className="container  h-100-minusAppBar" key="maincontainer">
      <div className="row align-items-center h-100">
        <div className="col-12 pt-3">
          <ReminderList
            reminders={sortedReminders}
            timeSeparation
            handleSnackbarOpen={handleSnackbarOpen}
            onIsReadButtonClick={loadReminders}
            onDeleteButtonClick={loadReminders}
            onEditButtonClick={loadReminders}
            onRowClick={liftUpStateToApp}
            errorHandling={errorHandling}
          />
        </div>
      </div>
    </div>
  );
};

CompaniesRemindersPage.propTypes = {
  handleSnackbarOpen: PropTypes.func.isRequired,
  liftUpStateToApp: PropTypes.func.isRequired,
  errorHandling: PropTypes.func.isRequired
};

export default CompaniesRemindersPage;
